/** Ensures that the value is a number, specifically an integer */
export const ensureInt = (val: string | number) => (typeof val === 'string' ? parseInt(val) : val)

/** Ensures that the value is a number, specifically an float */
export const ensureFloat = (val: string | number) =>
    typeof val === 'string' ? parseFloat(val) : val
